import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { CloudinaryImage, PRODUCT_CARD_IMAGE_CONFIG } from '../../../Image';
import { IMAGE_SIZE } from '../../ProductCardV2.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Image = (props: ProductCardV2ImageProps) => {
  const { source, alt, isUnavailable = false, priority, size = 'medium' } = props;

  const containerStyles = [styles.container, size === 'small' ? styles.containerSmall : undefined];
  const imageStyles = [
    size === 'small' ? styles.imageSmall : styles.image,
    isUnavailable ? styles.imageUnavailable : undefined,
  ];

  return (
    <View style={containerStyles}>
      <CloudinaryImage
        baseUrl={source}
        config={PRODUCT_CARD_IMAGE_CONFIG}
        contentFit="contain"
        aria-label={alt}
        priority={priority}
        style={imageStyles}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    borderRadius: theme.radius.medium,
  },
  containerSmall: {
    overflow: 'hidden',
    borderRadius: theme.radius.medium,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  image: {
    width: '100%',
    height: IMAGE_SIZE,
  },
  imageSmall: {
    width: '100%',
    aspectRatio: 1,
  },
  imageUnavailable: {
    opacity: 0.6,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ProductCardV2ImageProps = {
  source: string;
  alt?: string;
  isUnavailable?: boolean;
  priority?: ComponentProps<typeof CloudinaryImage>['priority'];
  size?: 'medium' | 'small';
};
